import { render, staticRenderFns } from "./Btn.vue?vue&type=template&id=395af7d9&scoped=true&lang=pug&"
import script from "./Btn.vue?vue&type=script&lang=js&"
export * from "./Btn.vue?vue&type=script&lang=js&"
import style0 from "./Btn.vue?vue&type=style&index=0&id=395af7d9&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395af7d9",
  null
  
)

export default component.exports